module.exports = __webpack_public_path__ + "static/media/full-screen-image-1.3b3892d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/full-screen-image-1.jpg
// module id = 1007
// module chunks = 0